
import storage from '../storage';
/*
function getBoolean(value){
  console.log('boolean', value);
}
*/
export default {
  plugin: (store) => {
    store.subscribe((mutation) => {
      if (mutation.type === 'setToken') {
        if(storage.isLSAvailable){
          localStorage.setItem('authenticationToken', mutation.payload);
        }
      } else if (mutation.type === 'resetToken') {
        localStorage.setItem('authenticationToken', '');
      }
    });
  },
  registerListener(store){
    window.addEventListener('storage', async function(e) {
      if(e.key === 'authenticationToken'){
        if(e.oldValue === e.newValue){
          console.log('same token');
        } else if(e.newValue !== '') {
          const token = e.newValue
          try{
            await store.dispatch('login', {method:'token', token})
          } catch (e) {
            console.error('Storage listener login failed', e.message);
          }
        } else {
          await store.dispatch('gotoLogin');
          console.log('Token not set');
          store.commit('resetToken');
        }
      }
    });
  }

}
